import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { GifItem, ModalBox } from './styles';
import { getSearchedGIF } from '../../../services/chatMessageUtilService';
import { isEmpty } from '../../../helpers/common';
import { observer } from 'mobx-react-lite';
import EmptyStateV2 from '../../emptyState';
import { EMPTY_STATE_SIZE } from '../../../global/constants';
import ModalHeader from '../modalHeader';
import Image from '../../image';

function InsertGifModal({
  setSelectedGif,
  closeModal
}: {
  setSelectedGif: (url: string) => void;
  closeModal: () => void;
}) {
  // Ref variable
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  //states
  const [searchValue, setSearchValue] = useState<string>('');
  const [gifData, setGifData] = useState<string[]>([]);

  const loadData = useCallback(async () => {
    const data = await getSearchedGIF('');
    setGifData(data);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handleSearchInput = useCallback((value: string) => {
    setSearchValue(value);

    // Clear the previous timeout if it exists
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set a new timeout
    timeoutRef.current = setTimeout(async () => {
      const data = await getSearchedGIF(value);
      setGifData(data);
    }, 1000);
  }, []);

  const handleSelectGif = useCallback(
    (url: string) => {
      setSelectedGif(url);
      closeModal();
    },
    [closeModal, setSelectedGif]
  );

  const renderGifItem = useMemo(() => {
    return (
      <GifItem>
        {gifData &&
          gifData?.length > 0 &&
          gifData?.map((gif: string) => (
            <div role='button' key={gif} className='gif-container' tabIndex={0} onClick={() => handleSelectGif(gif)}>
              <Image src={gif} alt='GIF' />
            </div>
          ))}
      </GifItem>
    );
  }, [handleSelectGif, gifData]);

  return (
    <ModalBox>
      <ModalHeader
        onClose={closeModal}
        placeHolder='Search for a gif'
        onSearchChange={handleSearchInput}
        searchValue={searchValue}
      />
      {renderGifItem}
      {isEmpty(gifData) && (
        <EmptyStateV2
          size={EMPTY_STATE_SIZE.SMALL}
          title='No results found'
          description='Try changing your search term.'
          imageUrl='gif_empty'
          isAlignedCenter={true}
        />
      )}
    </ModalBox>
  );
}

export default observer(InsertGifModal);
